import React, {useState} from "react";
import {ClipBoardService} from "../../../service/ClipBoardService";
import {useTranslation} from "react-i18next";

export const SPFGeneratorForm = () => {
    const [spfSettings, setSpfSettings] = useState({
        ip4: '',
        ip6: '',
        include: '',
        a: false,
        mx: false,
        allMechanism: '~all'
    });

    const [dnsEntry, setDnsEntry] = useState('');
    const clipboarService = new ClipBoardService();
    const {t} = useTranslation();

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setSpfSettings(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const generateSpfRecord = ({
                                   ip4,
                                   ip6,
                                   include,
                                   a,
                                   mx,
                                   allMechanism
                               }) => {
        let parts = ['v=spf1'];

        if (ip4.trim()) parts.push(`ip4:${ip4.trim()}`);
        if (ip6.trim()) parts.push(`ip6:${ip6.trim()}`);
        if (include.trim()) parts.push(`include:${include.trim()}`);
        if (a) parts.push('a');
        if (mx) parts.push('mx');

        parts.push(allMechanism || '~all');
        return parts.join(' ');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setDnsEntry(generateSpfRecord(spfSettings));
    };

    return (
        <div className={"container-fluid"}>
            <form onSubmit={handleSubmit}
                  className="mb-4 bg-white p-4 p-md-5 rounded rounded-3 shadow d-flex flex-column">

                <div className="mb-3">
                    <label htmlFor="ip4" className="form-label d-flex align-items-center">
                        {t("pages.spfGenerator.generator.form.ip4.title")}
                        <i className="bi bi-info-circle ms-2"
                           data-bs-toggle="tooltip"
                           data-bs-placement="right"
                           title={t("pages.spfGenerator.generator.form.ip4.info")}
                           style={{cursor: 'pointer'}}></i>
                    </label>
                    <input
                        type="text"
                        id="ip4"
                        name="ip4"
                        value={spfSettings.ip4}
                        onChange={handleChange}
                        className="form-control"
                        placeholder={t("pages.spfGenerator.generator.form.ip4.placeholder")}
                    />
                </div>

                <div className="mb-3">
                    <label htmlFor="ip6" className="form-label d-flex align-items-center">
                        {t("pages.spfGenerator.generator.form.ip6.title")}
                        <i className="bi bi-info-circle ms-2"
                           data-bs-toggle="tooltip"
                           data-bs-placement="right"
                           title={t("pages.spfGenerator.generator.form.ip6.info")}
                           style={{cursor: 'pointer'}}></i>
                    </label>
                    <input
                        type="text"
                        id="ip6"
                        name="ip6"
                        value={spfSettings.ip6}
                        onChange={handleChange}
                        className="form-control"
                        placeholder={t("pages.spfGenerator.generator.form.ip6.placeholder")}
                    />
                </div>

                <div className="mb-3">
                    <label htmlFor="include" className="form-label d-flex align-items-center">
                        {t("pages.spfGenerator.generator.form.include.title")}
                        <i className="bi bi-info-circle ms-2"
                           data-bs-toggle="tooltip"
                           data-bs-placement="right"
                           title={t("pages.spfGenerator.generator.form.include.info")}
                           style={{cursor: 'pointer'}}></i>
                    </label>
                    <input
                        type="text"
                        id="include"
                        name="include"
                        value={spfSettings.include}
                        onChange={handleChange}
                        className="form-control"
                        placeholder={t("pages.spfGenerator.generator.form.include.placeholder")}
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label d-flex align-items-center">
                        {t("pages.spfGenerator.generator.form.flags.title")}
                        <i className="bi bi-info-circle ms-2"
                           data-bs-toggle="tooltip"
                           data-bs-placement="right"
                           title={t("pages.spfGenerator.generator.form.flags.info")}
                           style={{cursor: 'pointer'}}></i>
                    </label>
                    <div className="form-check form-check-inline">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            name="a"
                            id="spf-flag-a"
                            checked={spfSettings.a}
                            onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor="spf-flag-a">a</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            name="mx"
                            id="spf-flag-mx"
                            checked={spfSettings.mx}
                            onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor="spf-flag-mx">mx</label>
                    </div>
                </div>

                <div className="mb-3">
                    <label htmlFor="allMechanism" className="form-label d-flex align-items-center">
                        {t("pages.spfGenerator.generator.form.all.title")}
                        <i className="bi bi-info-circle ms-2"
                           data-bs-toggle="tooltip"
                           data-bs-placement="right"
                           title={t("pages.spfGenerator.generator.form.all.info")}
                           style={{cursor: 'pointer'}}></i>
                    </label>
                    <select
                        name="allMechanism"
                        id="allMechanism"
                        value={spfSettings.allMechanism}
                        onChange={handleChange}
                        className="form-select"
                    >
                        <option value="~all">~all (Soft fail)</option>
                        <option value="-all">-all (Fail)</option>
                        <option value="+all">+all (Allow)</option>
                        <option value="?all">?all (Neutral)</option>
                    </select>
                </div>

                <div className="mb-3 text-end">
                    <button type="submit" className="btn btn-primary text-white">
                        {t("pages.spfGenerator.generator.form.generate")}
                    </button>
                </div>

                {dnsEntry && (
                    <div className={"alert alert-success"}>
                        <h4>{t("pages.spfGenerator.generator.form.result.title")}</h4>
                        <p>{t("pages.spfGenerator.generator.form.result.subTitle")}</p>
                        <hr/>
                        <div className="d-flex justify-content-between flex-wrap">
                            <p className="font-monospace">{dnsEntry}</p>
                            <div>
                                <button className="btn btn-primary text-white" onClick={() => clipboarService.handleCopy(dnsEntry)}>
                                    {t("pages.spfGenerator.generator.form.result.copy")}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </form>
        </div>
    );
};
